// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.is-primary-icon[data-v-404fee5c] {
  position: relative;
}
.is-primary-icon[data-v-404fee5c]:after {
  content: ' ';
  top: 0;
  position: absolute;
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background-color: var(--color-primary);
}
`, "",{"version":3,"sources":["webpack://./src/components/base/filterTplPro/tpl/fieldTypeIcon.vue","webpack://./fieldTypeIcon.vue"],"names":[],"mappings":"AA6CA;EACE,kBAAA;AC5CF;AD8CE;EACE,YAAA;EACA,MAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,sCAAA;AC5CJ","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.is-primary-icon {\n  position: relative;\n\n  &:after {\n    content: ' ';\n    top: 0;\n    position: absolute;\n    width: 3px;\n    height: 3px;\n    border-radius: 50%;\n    background-color: var(--color-primary);\n  }\n}\n",".is-primary-icon {\n  position: relative;\n}\n.is-primary-icon:after {\n  content: ' ';\n  top: 0;\n  position: absolute;\n  width: 3px;\n  height: 3px;\n  border-radius: 50%;\n  background-color: var(--color-primary);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
